import React from 'react';

interface IOwnProps {
    hasArrow?: boolean;
}

type Props = IOwnProps;

class ActivityList extends React.Component<Props, {}> {
    public render() {
        if (!this.props.children) {
            return null;
        }

        return <ul className={'activity-list'.cAppend(this.props.hasArrow, 'has-arrow')}>
            {this.props.children}
        </ul>;
    }
}

export default ActivityList;